enum ImpressionVerifierVendorEnum {
  GEOPATH = 'Geopath',
  MOVE = 'MOVE',
  ROUTE = 'Route',
  COMMB = 'COMMB',
  OMC = 'OMC',
  LINKETT = 'Linkett',
  EPICENTER = 'Epicenter',
  COMSCORE = 'ComScore',
  QUIVIDI = 'Quividi',
  BLIMP = 'Blimp',
  MIRAREVEALMOBILE = 'Mira/Reveal Mobile',
  STREETMETRICS = 'Streetmetrics',
  NIELSEN = 'Nielsen',
  KANTAR = 'Kantar',
  OUTDOORIMPACT = 'Outdoor Impact',
  ISBA = 'ISBA',
}

export default ImpressionVerifierVendorEnum;
